import logoPng from "icon/mainLogo.svg";
import logoPng2 from "icon/mainLogo2.svg";
import mainLogoColor from "icon/mainLogoColor.png";

export const LogoPng = ({ width, height }: { width: number; height: number }) => (
  <img src={logoPng} width={width} height={height} alt="DPI Logo" />
);

export const LogoPngVerTwo = ({ width, height }: { width: number; height: number }) => (
  <img src={logoPng2} width={width} height={height} alt="DPI Logo" />
);

export const LogoColorPng = ({ width, height }: { width: number; height: number }) => (
  <img src={mainLogoColor} width={width} height={height} alt="DPI Logo" />
);

